import React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Chip } from "@mui/material";

const PortfolioGridAMTable = () => {
  const columns = [
    { field: "id", headerName: "Asset ID", width: 80, hide: true },
    {
      field: "assetType",
      headerName: "Asset Category",
      width: 140,
      editable: false,
    },
    {
      field: "buildingName",
      headerName: "Building Name",
      width: 250,
      editable: false,
    },
    {
      field: "location",
      headerName: "Location",
      width: 180,
      editable: false,
    },
    {
      field: "room",
      headerName: "Room",
      width: 120,
      editable: false,
    },
    {
      field: "spaceUtilization",
      headerName: "Space Utilization",
      width: 150,
      editable: false,
    },
    {
      field: "runningCost",
      headerName: "Running Cost ($)",
      width: 150,
      editable: false,
    },
    {
      field: "lastLocationUpdateDate",
      headerName: "Last Location Update Date",
      width: 200,
      editable: false,
    },
    {
      field: "peakUtilizationPeriods",
      headerName: "Peak Utilization Periods",
      width: 200,
      editable: false,
    },
  ];

  const rows = [
    {
      id: 1,
      assetType: "Workstation",
      buildingName: "Contoso Tower - Toronto",
      location: "Floor 1, East Wing",
      room: "Office 101",
      spaceUtilization: "85%",
      runningCost: 1200,
      lastLocationUpdateDate: "2024-10-01",
      peakUtilizationPeriods: "9 AM - 5 PM",
    },
    {
      id: 2,
      assetType: "Lighting System",
      buildingName: "Contoso Plaza - Ottawa",
      location: "Floor 2, Main Area",
      room: "Conference Room",
      spaceUtilization: "100%",
      runningCost: 300,
      lastLocationUpdateDate: "2024-09-15",
      peakUtilizationPeriods: "All Day",
    },
    {
      id: 3,
      assetType: "Security Camera",
      buildingName: "Contoso Residences - Vancouver",
      location: "Exterior",
      room: "Building Perimeter",
      spaceUtilization: "95%",
      runningCost: 150,
      lastLocationUpdateDate: "2024-09-30",
      peakUtilizationPeriods: "Evenings",
    },
    {
      id: 4,
      assetType: "Printer",
      buildingName: "Contoso Innovation Hub - Calgary",
      location: "Floor 3, Lab Area",
      room: "Print Station",
      spaceUtilization: "70%",
      runningCost: 100,
      lastLocationUpdateDate: "2024-10-05",
      peakUtilizationPeriods: "10 AM - 4 PM",
    },
    {
      id: 5,
      assetType: "HVAC",
      buildingName: "Contoso Heights - Montreal",
      location: "Floor 4, Mechanical Room",
      room: "HVAC Control",
      spaceUtilization: "100%",
      runningCost: 2500,
      lastLocationUpdateDate: "2024-09-20",
      peakUtilizationPeriods: "All Day",
    },
    {
      id: 6,
      assetType: "Security Camera",
      buildingName: "Contoso Wellness Center - Halifax",
      location: "Entrance",
      room: "Reception Area",
      spaceUtilization: "90%",
      runningCost: 200,
      lastLocationUpdateDate: "2024-10-10",
      peakUtilizationPeriods: "Morning Shift",
    },
    {
      id: 7,
      assetType: "Printer",
      buildingName: "Contoso Retail Space - Edmonton",
      location: "Floor 1, Front",
      room: "Customer Service",
      spaceUtilization: "80%",
      runningCost: 120,
      lastLocationUpdateDate: "2024-10-12",
      peakUtilizationPeriods: "11 AM - 1 PM",
    },
    {
      id: 8,
      assetType: "Lighting System",
      buildingName: "Contoso Eco Park - Saskatoon",
      location: "Park Area",
      room: "Visitor Center",
      spaceUtilization: "70%",
      runningCost: 180,
      lastLocationUpdateDate: "2024-09-25",
      peakUtilizationPeriods: "Evenings",
    },
    {
      id: 9,
      assetType: "HVAC",
      buildingName: "Contoso Tower - Victoria",
      location: "Floor 2, Mechanical Room",
      room: "HVAC Control",
      spaceUtilization: "100%",
      runningCost: 2200,
      lastLocationUpdateDate: "2024-10-02",
      peakUtilizationPeriods: "All Day",
    },
    {
      id: 10,
      assetType: "Workstation",
      buildingName: "Contoso Conference Center - Winnipeg",
      location: "Hall A",
      room: "Main Hall",
      spaceUtilization: "75%",
      runningCost: 1400,
      lastLocationUpdateDate: "2024-10-01",
      peakUtilizationPeriods: "Event Days",
    },
  ];
  

  return (
    <>
      <Box sx={{ height: "350px", width: "100%", overflow: "auto" }}>
        <DataGrid
          sx={{
            color: "white",
            "& .MuiDataGrid-menuIconButton": {
              color: "white",
            },
            "& .MuiCheckbox-root": {
              color: "white",
            },

            "& .MuiDataGrid-sortIcon": {
              color: "white",
            },

            "& .MuiTablePagination-root": {
              bgcolor: "white",
            },
            "& .MuiDataGrid-cell": {
              border: 0,
            },
            "& .MuiDataGrid-row:hover": {
              bgcolor: "primary.main",
            },
            "& .MuiDataGrid-cell:hover": {
              bgcolor: "none",
            },
            "& .MuiDataGrid-cell:focus": {
              bgcolor: "primary.light",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
              lineHeight: "1.5",
              whiteSpace: "normal",
            },

            "& .MuiDataGrid-cell": {
              textAlign: "center", // Centering cell content
            },
          }}
          rows={rows}
          columns={columns}
          initialState={{}}
          checkboxSelection
          disableRowSelectionOnClick
        />
      </Box>
    </>
  );
};

export default PortfolioGridAMTable;
